import React, { useState, useEffect, useCallback } from 'react';

interface BreakpointProps {
  children: (breakpoint: string) => React.ReactNode;
}

const Breakpoint: React.FC<BreakpointProps> = ({ children }) => {
  const getBreakpoint = useCallback((): string => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return '';
    }

    const body = document.querySelector('body') as HTMLBodyElement;
    if (!body) {
      console.warn('Body element not found. Cannot determine breakpoint.');
      return '';
    }

    return window
      .getComputedStyle(body, ':before')
      .getPropertyValue('content')
      .replace(/"/g, ''); // Remove quotes from the string value
  }, []);

  const [breakpoint, setBreakpoint] = useState<string>(getBreakpoint());

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakpoint());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [getBreakpoint]);

  return <>{children(breakpoint)}</>;
};

export default Breakpoint;